export const postData = async ( url = '', data = {} ) => {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: data
  });
  return response.json();
}